import { Button, IconButton, makeStyles, withStyles } from '@material-ui/core';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import CommentIcon from '@material-ui/icons/Message';
import { usePopupState } from 'material-ui-popup-state/hooks';
import React from 'react';
import styled from 'styled-components';
import FormikSimpleSelect from '../../common/FormikSimpleSelect';
import ActionsContextV2 from '../ActionsContextV2';
import ActionItemAlternateSdnV2 from './ActionItemAlternateSdnV2';
import ActionItemButton from './ActionItemButton';
import ActionApprovalTypePillV2 from './ActionApprovalTypePillV2';
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableRow from "@material-ui/core/TableRow";
import { connect } from 'react-redux';

const TableCell = withStyles({
    root: props => ({
        borderBottom: "none"
    })
})(MuiTableCell);

const TableRow = withStyles({
    root: props => ({
        borderBottom: props.isEditingAlternateSDN ? "none" : "1px solid rgba(224, 224, 224, 1)"
    })
})(MuiTableRow);

const AltSDNContainer = styled.div` 
  min-width:105px;
`;

const useStyles = makeStyles((theme) => ({
    root: {
        color: 'inherit',
        '&$hover:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    //hover: {},
}));

const RETURN_VALUE = 'Return';

const ActionsPendingFormItemV2 = (props) => {
    const context = React.useContext(ActionsContextV2);
    const classes = useStyles();

    const { formProps, groupIndex, itemIndex, currentUserStepIndex, action, readOnly, selectedProject } = props;

    const hyphenIfNull = text => text ? text : '-';

    const statusActionButtonTitleValues = [
        { title: 'Approve', value: 'Approve' },
        { title: 'Return', value: RETURN_VALUE }
    ];

    const currentStepIndex = context.actionsRedux.selectedProjectFunctionDetails.currentStepIndex;

    const masterWorkflowStep = context.actionsRedux.selectedProjectFunctionDetails.masterWorkflowSteps[currentStepIndex];
    let isEditable = masterWorkflowStep && (masterWorkflowStep.isCurrentUser || masterWorkflowStep.isProxy);

    isEditable = true;

    const { procedureSdn, rev, effectiveDate, submitByDate, status, applicability, alternateSdn, alternateUrl, procedureComments } = action;
    const isLevel1Editable = (currentStepIndex === 0 && isEditable)
    // const isLevelAbove1Editable = (currentStepIndex && currentStepIndex > 0 && isEditable)
    const isLevelAbove1Editable = (currentStepIndex && currentStepIndex >= 0 && isEditable)




    const { procedureName, iwpp, url, categoryName, statusAction } = action;

    // For Project Specific procedure for stepindex 0 set statusAction to Approve by default
    if (categoryName === 'PROJECT' && currentStepIndex === 0 && statusAction === null) {
        action.statusAction = 'Approve';
    }

    const isEditingAlternateSDN = context.alternateSdnAction && context.alternateSdnAction.procedureId === action.procedureId;
    const disabledStyle = (context.alternateSdnAction && !isEditingAlternateSDN) ?
        { opacity: .5, pointerEvents: 'none' } : {};

    let updatingStatus = context.actionsRedux.selectedProjectFunctionDetailsUpdates[action.procedureId];
    updatingStatus = updatingStatus ? updatingStatus : {};

    const urlToUse = alternateUrl ? alternateUrl : url;
    const sdnToUse = alternateSdn ? alternateSdn : procedureSdn;

    let shouldAutoApproveProcedures = false;
    let projectShouldAutoApproveProcedures = false;
    if (selectedProject) {
        const selectedFunctionId = selectedProject.selectedFunction ? selectedProject.selectedFunction.id : 0;

        const selectedFunction = selectedProject.functions.find((functionTemp) => {
            return functionTemp.id == selectedFunctionId;
        });

        shouldAutoApproveProcedures = selectedFunction ? selectedFunction.shouldAutoApproveProcedures : false;
        projectShouldAutoApproveProcedures = selectedFunction ? selectedFunction.projectShouldAutoApproveProcedures : false;
    }

    // const defaultComplyAsIs = action.applicabilityId != null ? action.applicabilityId : (shouldAutoApproveProcedures && projectShouldAutoApproveProcedures) ? 'YES' : '';
    const defaultComplyAsIs = action.applicabilityId;


    return (
        <>
            <TableRow hover classes={classes} isEditingAlternateSDN={isEditingAlternateSDN}
                onMouseEnter={() => {
                    context.setProcedureSdnWithRev(action.procedureSdn + action.rev);
                    context.setHoverAction(action);
                }}
                onMouseLeave={() => {
                    context.setProcedureSdnWithRev('');
                    context.setHoverAction(null);
                }}
            >
                <TableCell  >
                    <ActionApprovalTypePillV2 action={action} />
                </TableCell>
                <TableCell>
                    {(urlToUse && !readOnly) ?
                        <a target="_blank" href={urlToUse}>{sdnToUse}</a>
                        : sdnToUse
                    }
                </TableCell>
                <TableCell>
                    {procedureName}
                </TableCell>
                <TableCell>
                    {categoryName ? categoryName : "-"}
                </TableCell>
                <TableCell>
                    {rev}
                </TableCell>
                <TableCell>
                    {isLevel1Editable ?
                        <FormikSimpleSelect
                            // loading
                            buttonTitleValues={context.actionsRedux.applicabilityOptions}
                            value={defaultComplyAsIs}
                            // value={action.applicabilityId}
                            loading={updatingStatus.applicabilityId !== undefined}

                            onValueChanged={value => {
                                if (value != 'NO') { // We are handeling case of 'NO' in onclick event so excluding it from here 
                                    const applicabilityOption = context.actionsRedux.applicabilityOptionsObject[value];

                                    if (applicabilityOption && applicabilityOption.requiresDeviationReasoning === true) {
                                        context.displayDeviationReasoning({ action: { ...action, applicabilityId: value }, deviationReasoningClearApplicabilityOnCancel: true, isEditable });
                                    } else {
                                        // we need to make following fields empty on selecting Yes. comply as-is
                                        let tempAction = { ...action }
                                        if (value == 'YES') {
                                            tempAction = {
                                                ...action,
                                                deviationType: 0,
                                                isDeviating: false,
                                                modifiedProcedureEffectiveDate: '',
                                                modifiedProcedureRev: '',
                                                modifiedProcedureSdn: '',
                                                modifiedProcedureTitle: '',
                                                modifiedProcedureUrl: '',
                                                deviationReasoning: '',
                                                deviationComments: ''
                                            }
                                        }

                                        // context.updateAction(action, { applicabilityId: value, deviationReasoning: null, deviationComments: null });

                                        // renoving deviationReasoning:null,deviationComments:null as now we dont want reset it as null again
                                        if (value != 'YES') {
                                            props.setSetAllToComplyAsIsFlag(false)
                                        }
                                        context.updateAction(tempAction, { applicabilityId: value });
                                    }

                                    context.updateScrollTop(context.scrollRef.current.scrollTop);
                                }
                            }}

                            OnOptionClick={value => {
                                if (value == 'NO') {
                                    const applicabilityOption = context.actionsRedux.applicabilityOptionsObject[value];

                                    if (applicabilityOption && applicabilityOption.requiresDeviationReasoning === true) {
                                        context.displayDeviationReasoning({ action: { ...action, applicabilityId: value }, deviationReasoningClearApplicabilityOnCancel: true, isEditable });
                                    } else {
                                        let tempAction = { ...action }
                                        if (value != 'YES') {
                                            props.setSetAllToComplyAsIsFlag(false)
                                        }
                                        context.updateAction(tempAction, { applicabilityId: value });
                                    }

                                    context.updateScrollTop(context.scrollRef.current.scrollTop);
                                }
                            }}
                        /> :
                        hyphenIfNull(applicability)
                    }

                </TableCell>
                {!readOnly &&
                    <TableCell>

                        {(action.deviationReasoning || action.deviationComments || action.activeOneTimeDeviation) &&
                            <ActionItemButton
                                onClick={() => context.displayDeviationReasoning({ action, deviationReasoningClearApplicabilityOnCancel: false, isEditable })}
                            >
                                View Reason
                            </ActionItemButton>
                        }

                    </TableCell>
                }




                {currentStepIndex > 0 &&

                    <TableCell>
                        {/* {isLevelAbove1Editable ?
                                            <FormikSimpleSelect
                                                buttonTitleValues={statusActionButtonTitleValues}
                                                value={action.statusAction}
                                                loading={updatingStatus.statusAction !== undefined}
                                                onValueChanged={value => {

                                                    if (value === RETURN_VALUE) {
                                                        context.displayComments({commentsClearStatusActionOnCancel:true,action:{...action,statusAction:value},commentsEditable:isLevelAbove1Editable,allowCancel:false});
                                                    } else {
                                                        context.updateAction(action,{statusAction:value,comments:null});
                                                        
                                                    }
                                                    
                                                    context.updateScrollTop(context.scrollRef.current.scrollTop);

                                                }}
                                            /> :
                                            hyphenIfNull(status)
                                            
                    } */}
                        {
                            <FormikSimpleSelect
                                buttonTitleValues={statusActionButtonTitleValues}
                                value={action.statusAction}
                                loading={updatingStatus.statusAction !== undefined}
                                onValueChanged={value => {

                                    if (value === RETURN_VALUE) {
                                        context.displayComments({ commentsClearStatusActionOnCancel: true, action: { ...action, statusAction: value }, commentsEditable: isLevelAbove1Editable, allowCancel: false });
                                    } else {
                                        context.updateAction(action, { statusAction: value, comments: null });

                                    }

                                    context.updateScrollTop(context.scrollRef.current.scrollTop);

                                }}
                            />
                        }

                    </TableCell>
                }

                {
                    <TableCell>
                        {/* {comments ? 
                            <IconButton 
                                color="primary"
                                onClick={ () => context.displayComments({action,commentsEditable:isLevelAbove1Editable})}
                            >
                                <CommentIcon/>
                            </IconButton>
                        : <IconButton disabled> <ChatBubbleOutline color="primary"/></IconButton>
                        } */}
                        {procedureComments && procedureComments.length ?
                            <IconButton
                                color="primary"
                                onClick={() => context.displayComments({ action, commentsEditable: isEditable })}
                            >
                                <CommentIcon />
                            </IconButton>
                            :
                            <IconButton
                                color="primary"
                                onClick={() => context.displayComments({ action, commentsEditable: isEditable })}
                            >
                                <ChatBubbleOutline color="primary" />
                            </IconButton>
                        }
                    </TableCell>
                }
                {isLevel1Editable && context.editAlternateSdn && !context.alternateSdnAction &&
                    <TableCell>
                        <AltSDNContainer>
                            <Button
                                fullWidth
                                style={{ height: 40 }}
                                color="primary"
                                variant={action.alternateSdn ? 'contained' : 'outlined'}
                                onClick={() => context.setAlternateSdnAction(action)}>
                                {action.alternateSdn ?
                                    <span>&#10003; Alt SDN</span> :
                                    <span>&#43; Alt SDN</span>
                                }
                            </Button>
                        </AltSDNContainer>
                    </TableCell>
                }


            </TableRow>

            {isEditingAlternateSDN &&
                <ActionItemAlternateSdnV2
                    context={context}
                    action={action}
                    onValueChanged={({ alternateSdn, alternateUrl }) => {


                        context.updateAction(action, { alternateSdn: alternateSdn ? alternateSdn : null, alternateUrl: alternateUrl ? alternateUrl : null });

                        context.setAlternateSdnAction(null);
                    }}
                />
            }

        </>

    );


}

const mapStateToProps = (state) => {
    return {
        selectedProject: state.actions.selectedProject,
    };
};

export default connect(mapStateToProps)(ActionsPendingFormItemV2);


// export default ActionsPendingFormItemV2;